import { FA_ROLES } from '@constants/member-roles';
import { Profile } from '@model/profile';
import { validateUserRoles } from './validate-user-roles';

/* Member refers to members of system (Financial Advisor) */
export default function isMember(profile: Profile): boolean {
  return validateUserRoles(profile, FA_ROLES);
}
